import React from 'react';
import {
  CorrelationRuleData,
  getYAMLSectionByField,
  YAMLField,
} from 'Pages/Build/Detections/CorrelationRules/utils';
import yaml from 'js-yaml';
import {
  DEFAULT_CORRELATION_RULE_YAML_MATCH_CRITERIA,
  DEFAULT_CORRELATION_RULE_YAML_TRANSITIONS,
} from 'Source/constants';

export const useToggleSequenceGroup = () => {
  const [transitions, setTransitions] = React.useState(
    (yaml.load(DEFAULT_CORRELATION_RULE_YAML_TRANSITIONS) as CorrelationRuleData).Transitions,
  );
  const [matchCriteria, setMatchCriteria] = React.useState(
    (yaml.load(DEFAULT_CORRELATION_RULE_YAML_MATCH_CRITERIA) as CorrelationRuleData).MatchCriteria,
  );
  const [groupMinMatchCount, setGroupMinMatchCount] = React.useState('');

  const toggleSequenceGroup = React.useCallback(
    parsedYaml => {
      const isSequence = parsedYaml?.Sequence?.length;

      if (isSequence) {
        // Switching to a Group
        // then save off the current Transitions
        setTransitions(parsedYaml?.Transitions);
        return `- ${
          parsedYaml?.Sequence
            ? `${getYAMLSectionByField(
                parsedYaml?.Sequence,
                YAMLField.Sequence,
                YAMLField.Group,
              )}\n\n`
            : ''
        }${
          matchCriteria
            ? `  ${getYAMLSectionByField(
                matchCriteria as CorrelationRuleData,
                YAMLField.MatchCriteria,
              )}\n\n`
            : ''
        }${groupMinMatchCount ? `  MinMatchCount: ${groupMinMatchCount}\n\n` : ''}${
          parsedYaml?.EventEvaluationOrder
            ? `  ${getYAMLSectionByField(
                parsedYaml?.EventEvaluationOrder,
                YAMLField.EventEvaluationOrder,
              )}\n\n`
            : ''
        }${
          parsedYaml?.LookbackWindowMinutes
            ? `  ${getYAMLSectionByField(
                parsedYaml?.LookbackWindowMinutes,
                YAMLField.LookbackWindowMinutes,
              )}\n\n`
            : ''
        }${
          parsedYaml?.Schedule
            ? `  ${getYAMLSectionByField(parsedYaml?.Schedule, YAMLField.Schedule)}`
            : ''
        }`;
      }
      // Switching to a Sequence
      // then save off the current Match Criteria
      setMatchCriteria(parsedYaml?.MatchCriteria);
      setGroupMinMatchCount(parsedYaml?.MinMatchCount);
      return `- ${
        parsedYaml?.Group
          ? `${getYAMLSectionByField(parsedYaml?.Group, YAMLField.Group, YAMLField.Sequence)}\n\n`
          : ''
      }${
        transitions
          ? `  ${getYAMLSectionByField(
              transitions as CorrelationRuleData,
              YAMLField.Transitions,
            )}\n\n`
          : ''
      }${
        parsedYaml?.EventEvaluationOrder
          ? `  ${getYAMLSectionByField(
              parsedYaml?.EventEvaluationOrder,
              YAMLField.EventEvaluationOrder,
            )}\n\n`
          : ''
      }${
        parsedYaml?.LookbackWindowMinutes
          ? `  ${getYAMLSectionByField(
              parsedYaml?.LookbackWindowMinutes,
              YAMLField.LookbackWindowMinutes,
            )}\n\n`
          : ''
      }${
        parsedYaml?.Schedule
          ? `  ${getYAMLSectionByField(parsedYaml?.Schedule, YAMLField.Schedule)}`
          : ''
      }`;
    },
    [matchCriteria, transitions, groupMinMatchCount],
  );

  return { toggleSequenceGroup };
};
